import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';

/**
 * Kontrola, že je zadán věk a způsob pěstování, pokud jde o sadební RM.
**/
@Injectable({
  providedIn: 'root'
})
export class VekAZpusobPestovaniRequiredValidator implements Validator {

  private sadebniRm: number = 2;

  validate(control: AbstractControl): ValidationErrors | null {
    let druhRm = control.parent?.get('druhRepMaterialu')?.value;
    if (druhRm?.value == this.sadebniRm && (control.value == void 0 || control.value == '')) {
      return { 'vekAZpusobPestovaniRequired': 'Pro sadební RM je věk a způsob pěstování povinný.' };
    }
    return null;
  }
}
